import { defineStore } from 'pinia'

export const useBreadCrumbsStore = defineStore('breadCrumbs', {
    state: () => ({
        /** item
         * title - String required
         * routeName - String or view - Object
         */
        items: [],
        showMobileBC: false,
        nextIndex: -1,
    }),

    getters: {
        nextIndexIsNotListed(state) {
            return !(state.nextIndex + 1)
        },

        needValidate(state) {
            const currentView = state.items[state.items.length - 1].view

            return this.nextIndexIsNotListed && currentView.validation
        },
    },

    actions: {
        setBreadCrumbs(items) {
            this.items = Array.isArray(items) ? items : [items]
        },

        addItem(item) {
            this.items.push(item)
        },

        addItemWithBack(item, quantity = 1) {
            this.items.splice(-1, quantity, item)
        },

        goBack(quantity = 1) {
            if (this.needValidate) {
                this.setNextIndex(this.items.length - 1 - quantity)

                return
            }

            this.items.splice(-1, quantity)
        },

        goBackByIndex(index, withoutValidation = false) {
            if (this.needValidate && !withoutValidation) {
                this.setNextIndex(index)

                return
            }

            this.setNextIndex(-1)

            this.items = this.items.slice(0, index + 1)
        },

        changeShowMobileBC(value) {
            this.showMobileBC = value
        },

        setNextIndex(index) {
            this.nextIndex = index
        },
    },
})
